// Camera.tsx
import React, { useState, useEffect } from 'react';
import './Camera.css';
import '../index.css';
import CAM01 from '../assets/videos/cam_01.mp4';
import CAM02 from '../assets/videos/cam_nosignal.mp4';
import CAM03 from '../assets/videos/cam_nosignal.mp4';
import CAM04 from '../assets/videos/cam_nosignal.mp4';
import CAM05 from '../assets/videos/cam_nosignal.mp4';

const Camera: React.FC<{ title?: string }> = ({ title = 'Camera' }) => {
  const videos = [CAM01, CAM02, CAM03, CAM04, CAM05];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentTime, setCurrentTime] = useState('');

  const updateCurrentTime = () => {
    const now = new Date();
    const year = now.getFullYear().toString().slice(-2);
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    
    setCurrentTime(`${year}/${month}/${day} ${hours}:${minutes}:${seconds}`);
  };

  useEffect(() => {
    updateCurrentTime();
  }, []);

  const prevImage = () => {
    setCurrentIndex((currentIndex - 1 + videos.length) % videos.length);
    updateCurrentTime();
  };

  const nextImage = () => {
    setCurrentIndex((currentIndex + 1) % videos.length);
    updateCurrentTime();
  };

  return (
      <div className="camera-window-content">
        <video 
          className="camera-view" 
          src={videos[currentIndex]} 
          autoPlay 
          loop
          playsInline 
        />
        <div className="camera-footer">
          <div className="camera-info">
            <div className='camera-info-number'>CAM0{currentIndex + 1}</div>
          <div className='camera-info-time'>{currentTime}</div>
        </div>
        <div className="camera-controls">
          <button className='previmage-btn btn-common btn-small' onClick={prevImage}>&lt;</button>
          <button className='nextimage-btn btn-common btn-small' onClick={nextImage}>&gt;</button>
        </div>
      </div>
    </div>
  );
};

export default Camera;